import React, { PureComponent } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { cloneDeep, set } from 'lodash';
import { withRouter } from 'react-router-dom';
import Autocomplete from 'react-google-autocomplete';
import get from 'lodash/get';

import { parseAddress } from '../../common/services/utils';
import { getCompany, saveCompany } from '../services/company.service';
import CompanyModel from '../models/company.model';

import { Breadcrumb, Input, CustomSelect } from '../../common/components';
import { getVoivodeships, getCompanyGroups } from '../../dictionary/services/dictionary.service';

const optionsAdmin = [
  { value: 0, label: 'Komis' },
  { value: 1, label: 'Stacja diagnostyczna' },
  { value: 2, label: 'Administrator' },
];

const optionsUser = [
  { value: 0, label: 'Komis' },
];

const initialState = {
  name: '',
  vatId: '',
  type: optionsUser[0],
  active: true,
  areBreakdownsVisible: false,
};

const getOptionLabel = (option) => option.label || option.name;

const getOptionValue = (option) => option.value || option.id;

class Company extends PureComponent {
  state = cloneDeep(initialState);

  async componentDidMount() {
    const { isAdmin, match: { params } } = this.props;
    this.options = isAdmin ? optionsAdmin : optionsUser;
    let company = {};

    if (params.id) {
      this.setState({
        isLoading: true,
      });

      company = await getCompany(params.id);
      Object.assign(company, {
        type: this.options.find((item) => item.value === company.type),
      });
    }

    const { data: voivodeships } = await getVoivodeships();
    const { data: companyGroups } = await getCompanyGroups();
    this.setState({
      ...company,
      isLoading: false,
      voivodeships,
      companyGroups,
      group: companyGroups.find((companyGroup) => companyGroup.name === 'Standard'),
    });
  }

  onInputChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  }

  onSelectChange = (_, type) => {
    this.setState({
      type,
    });
  }

  onCompanyGroupChange = (_, group) => {
    this.setState({
      group,
    });
  }

  voivodeshipChange = (data, voivodeship) => {
    const { state } = this;

    const newState = set(cloneDeep(state), data.path, voivodeship);

    this.setState(newState);
  }

  onAddressInputChange = (name, value) => {
    const { state } = this;

    const newState = set(cloneDeep(state), name, value);

    this.setState(newState);
  }

  onFormSave = async () => {
    const { history } = this.props;
    const { type } = this.state;

    const data = { ...this.state, type: type.value };
    const companyModel = new CompanyModel(data);
    const errors = companyModel.validate();

    if (!errors) {
      try {
        await saveCompany(companyModel.getData());
        history.replace('/companies');
      } catch (err) {
        console.log(err);
      }
    }

    this.setState({ errors });
  }

  selectPlace = (place, type) => {
    const {
      main_address,
      corespondence_address,
      voivodeships,
    } = this.state;
    const address = parseAddress(place);
    const findVoideship = voivodeships.find((item) => item.name === address.administrative_area_level_1);

    if (type === 'main_address') {
      this.setState({
        main_address: {
          ...main_address,
          ...address,
          address: place.formatted_address,
          voivodeship: findVoideship,
        },
      });
    }

    if (type === 'corespondence_address') {
      this.setState({
        corespondence_address: {
          ...corespondence_address,
          ...address,
          address: place.formatted_address,
          voivodeship: findVoideship,
        },
      });
    }
  }

  render() {
    const {
      name,
      vatId,
      main_address,
      corespondence_address,
      active,
      type,
      voivodeships,
      isLoading,
      errors,
      group,
      companyGroups,
      areBreakdownsVisible,
    } = this.state;

    const { match: { params } } = this.props;
    const title = params.id ? 'Edycja firmy' : 'Dodawanie nowej firmy';

    if (isLoading) {
      return null;
    }

    return (
      <>
        <Breadcrumb title={title} />
        <div className="content">
          <div className="card">
            <div className="card-header">Dane firmy</div>
            <div className="card-body card-block">
              <div className="form-horizontal">
                <Input
                  label="Nazwa"
                  id="name"
                  value={name}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />

                <Input
                  label="NIP"
                  id="vatId"
                  value={vatId}
                  onChange={this.onInputChange}
                  errors={errors}
                  horizontal
                />

                <Input
                  label="Aktywna"
                  id="active"
                  value={active}
                  onChange={this.onInputChange}
                  errors={errors}
                  type="checkbox"
                  horizontal
                />

                <div className="row form-group">
                  <div className="col col-md-3">
                    <label className="form-control-label">
                      Grupa klienta
                    </label>
                  </div>
                  <div className="col-12 col-md-9">
                    <CustomSelect
                      data={{ id: 'group' }}
                      value={group}
                      onChange={this.onCompanyGroupChange}
                      options={companyGroups}
                      getOptionLabel={getOptionLabel}
                      getOptionValue={getOptionValue}
                      errors={errors}
                    />
                  </div>
                </div>

                <div className="row form-group">
                  <div className="col col-md-3">
                    <label className="form-control-label">
                      Typ klienta
                    </label>
                  </div>
                  <div className="col-12 col-md-9">
                    <CustomSelect
                      data={{ id: 'type' }}
                      value={type}
                      onChange={this.onSelectChange}
                      options={this.options}
                      getOptionLabel={getOptionLabel}
                      getOptionValue={getOptionValue}
                      errors={errors}
                    />
                  </div>
                </div>

                <Input
                  label="Widzi awarie"
                  id="areBreakdownsVisible"
                  value={areBreakdownsVisible}
                  onChange={this.onInputChange}
                  errors={errors}
                  type="checkbox"
                  horizontal
                />
              </div>
            </div>
          </div>
          <div className="card mt-4">
            <div className="card-header">Dane adresowe</div>
            <div className="card-body card-block">
              <div className="row form-group">
                <div className="col col-md-3">
                  <label className="form-control-label">
                    Typ adresu
                  </label>
                </div>
                <div className="col-12 col-md-9">
                  Adres główny
                </div>
              </div>
              <div className="row form-group">
                <div className="col col-md-3">
                  <label className="form-control-label">
                    Adres
                  </label>
                </div>
                <div className="col-12 col-md-9">
                  <Autocomplete
                    types={['address']}
                    className="form-control"
                    onPlaceSelected={(address) => this.selectPlace(address, 'main_address')}
                    componentRestrictions={{ country: 'pl' }}
                  />
                </div>
              </div>

              <div className="row form-group">
                <div className="col col-md-3">
                  <label className="form-control-label">
                    Województwo
                  </label>
                </div>
                <div className="col-12 col-md-9">
                  <CustomSelect
                    data={{ path: 'main_address.voivodeship', id: 'main_address.voivodeship' }}
                    value={get(main_address, 'voivodeship')}
                    onChange={this.voivodeshipChange}
                    options={voivodeships}
                    errors={errors}
                  />
                </div>
              </div>

              <Input
                label="Kod pocztowy"
                id="main_address.postal_code"
                value={get(main_address, 'postal_code')}
                onChange={this.onAddressInputChange}
                errors={errors}
                horizontal
              />

              <Input
                label="Miasto"
                id="main_address.locality"
                value={get(main_address, 'locality')}
                onChange={this.onAddressInputChange}
                errors={errors}
                horizontal
              />

              <Input
                label="Ulica"
                id="main_address.route"
                value={get(main_address, 'route')}
                onChange={this.onAddressInputChange}
                errors={errors}
                horizontal
              />

              <Input
                label="Numer"
                id="main_address.street_number"
                value={get(main_address, 'street_number')}
                onChange={this.onAddressInputChange}
                errors={errors}
                horizontal
              />
            </div>
            <div className="card-body card-block">
              <div className="row form-group">
                <div className="col col-md-3">
                  <label className="form-control-label">
                    Typ adresu
                  </label>
                </div>
                <div className="col-12 col-md-9">
                  Adres korespondencyjny
                </div>
              </div>
              <div className="row form-group">
                <div className="col col-md-3">
                  <label className="form-control-label">
                    Adres
                  </label>
                </div>
                <div className="col-12 col-md-9">
                  <Autocomplete
                    types={['address']}
                    className="form-control"
                    onPlaceSelected={(address) => this.selectPlace(address, 'corespondence_address')}
                    componentRestrictions={{ country: 'pl' }}
                  />
                </div>
              </div>

              <div className="row form-group">
                <div className="col col-md-3">
                  <label className="form-control-label">
                    Województwo
                  </label>
                </div>
                <div className="col-12 col-md-9">
                  <CustomSelect
                    data={{ path: 'corespondence_address.voivodeship', id: 'corespondence_address.voivodeship' }}
                    value={get(corespondence_address, 'voivodeship')}
                    onChange={this.voivodeshipChange}
                    options={voivodeships}
                  />
                </div>
              </div>

              <Input
                label="Kod pocztowy"
                id="corespondence_address.postal_code"
                value={get(corespondence_address, 'postal_code')}
                onChange={this.onAddressInputChange}
                horizontal
              />

              <Input
                label="Miasto"
                id="corespondence_address.locality"
                value={get(corespondence_address, 'locality')}
                onChange={this.onAddressInputChange}
                horizontal
              />

              <Input
                label="Ulica"
                id="corespondence_address.route"
                value={get(corespondence_address, 'route')}
                onChange={this.onAddressInputChange}
                horizontal
              />

              <Input
                label="Numer"
                id="corespondence_address.street_number"
                value={get(corespondence_address, 'street_number')}
                onChange={this.onAddressInputChange}
                horizontal
              />
            </div>
            <div className="d-flex justify-content-end p-4">
              <button
                type="button"
                onClick={this.onFormSave}
                className="btn btn-primary btn-sm"
              >
                Zapisz
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

Company.defaultProps = {};

Company.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withRouter(Company);
